import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Article from "../pages/article/page";
import Products from "../pages/products/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/pt/",
    element: <Home />,
  },
  {
    path: "/en/",
    element: <Home />,
  },
  {
    path: "/de/",
    element: <Home />,
  },
  {
    path: "/artigo/",
    element: <Article />,
  },
  {
    path: "/artigo/:slug",
    element: <Article />,
  },
  {
    path: "/article/",
    element: <Article />,
  },
  {
    path: "/article/:slug",
    element: <Article />,
  },
  {
    path: "/artikel/",
    element: <Article />,
  },
  {
    path: "/artikel/:slug",
    element: <Article />,
  },
  {
    path: "/products",
    element: <Products />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;